import React from 'react';
import { AsperWordmark } from 'assets/svg/AsperWordmark';
import { LoginCarousel } from 'components/organism/Login/LoginCarousel';
import { LoginFormCard } from 'components/organism/Login/LoginFormCard';
import type { LoginViewProps } from 'components/organism/Login/loginViewProps';

/**
 * V2 login screen (Figma "RGM Login Page"): sign-in card on the left, a
 * crossfading marketing carousel on the right. The carousel is dropped below
 * `lg` so the card centres on narrow viewports.
 */
export const LoginLayoutV2 = ({
    inputOnChange,
    emailRef,
    emailErrorMessage,
    passwordErrorMessage,
    errorMessage,
    loading,
    loginUser,
    handleSSOLogin,
    openResetPasswordModal,
    ssoIdpId,
    loginPageTextPart1,
    loginPageTextPart2,
}: LoginViewProps) => (
    <div className="flex h-screen w-screen bg-white">
        <div className="relative flex min-w-0 flex-1 items-center justify-center">
            <div className="flex flex-col items-center gap-[26px]">
                <LoginFormCard
                    inputOnChange={inputOnChange}
                    emailRef={emailRef}
                    emailErrorMessage={emailErrorMessage}
                    passwordErrorMessage={passwordErrorMessage}
                    errorMessage={errorMessage}
                    loading={loading}
                    loginUser={loginUser}
                    openResetPasswordModal={openResetPasswordModal}
                    loginPageTextPart1={loginPageTextPart1}
                    loginPageTextPart2={loginPageTextPart2}
                />

                {ssoIdpId && (
                    <div className="flex w-[400px] flex-col gap-8">
                        <div className="flex items-center gap-3">
                            <span className="h-px flex-1 bg-landingBorderStrong" />
                            <span className="font-plex text-[12px] font-medium leading-5 tracking-[-0.154px] text-navV2TextMuted">
                                OR
                            </span>
                            <span className="h-px flex-1 bg-landingBorderStrong" />
                        </div>

                        <button
                            type="button"
                            onClick={handleSSOLogin}
                            className="flex h-[60px] w-full cursor-pointer items-center justify-center gap-2 rounded-[12px] border border-solid border-landingBorderStrong bg-white px-6 font-plex text-[18px] font-medium leading-7 text-filterV2TextPrimary"
                        >
                            Sign in using SSO
                        </button>
                    </div>
                )}
            </div>

            <div className="absolute bottom-6 left-6 flex items-center gap-3">
                <span className="font-plex text-[16px] font-medium leading-normal text-navV2TextMuted">Powered by</span>
                <AsperWordmark className="h-12 w-[141px]" />
            </div>
        </div>

        <div className="hidden w-[53.89%] max-w-[776px] shrink-0 p-4 pl-0 lg:block">
            <LoginCarousel />
        </div>
    </div>
);
